<template>
    <v-data-table :headers="infoCabecalho" :items="itens" hide-actions
                  class="az-table-list tabela-item-detalhe">
        <template slot="items" slot-scope="props">
            <tr>
                <td>
                    {{ props.item.sequencia }}
                </td>
                <td>
                    <expansao-texto :tamanho="tamanho" :texto="props.item.descricao"/>
                </td>
                <td align="right">
                    {{ props.item.unidade }}
                </td>
                <td align="right">
                    {{ props.item.quantidade | cdCurrency('', qtdeCasasDecimais(casasDecimaisQuantidade)) }}
                </td>
                <td v-if="exibirValorDeReferencia && possuiValorReferencia" align="right">
                    {{ props.item.valorEstimado | cdCurrency(prefix, casasDecimais) }}{{suffix}}
                </td>
            </tr>
        </template>
    </v-data-table>
</template>

<script>
import {mapState} from 'vuex'
import qtdeCasasDecimais from '@/views/mixins/qtdeCasasDecimais'

export default {
    name: 'PainelLoteTabela',
    mixins: [qtdeCasasDecimais],
    props: {
        value: {},
        exibirValorDeReferencia: {
            type: Boolean,
            default: true
        },
        possuiValorReferencia: {},
        casasDecimais: {
            type: Number,
            default: 2
        },
        prefixOuSuffixValor:{
            type: String
        },
        criterioJulgamento:{
            type: String
        },
        isCriterioJulgamentoMaiorDesconto:{
            type: Boolean,
            default: false
        },
        casasDecimaisQuantidade: {
            type: Number,
            default: 2
        },
        itens: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            tamanho: null,
            colunas: [
                {
                    value: 'sequencia',
                    sortable: true,
                    width: '5%',
                    text: 'Seq',
                    class: 'primary--text',
                    align: 'left'
                },
                {
                    sortable: false,
                    align: 'left',
                    width: '50%',
                    value: 'descricao',
                    text: 'Descrição',
                    class: 'primary--text'
                },
                {
                    value: 'unidade',
                    width: '15%',
                    align: 'right',
                    text: 'Unidade',
                    sortable: false,
                    class: 'primary--text'
                },
                {
                    align: 'right',
                    sortable: false,
                    text: 'Quantidade',
                    value: 'quantidade',
                    width: '15%',
                    class: 'primary--text'
                },
                ... this.exibirValorDeReferencia && this.possuiValorReferencia ? [{
                    text: 'Valor Ref. Un.',
                    value: 'valorEstimado',
                    width: '15%',
                    sortable: false,
                    align: 'right',
                    class: 'primary--text'
                }] : [],
            ]
        }
    },
    computed: {
        ...mapState(['loki']),
        infoCabecalho() {
            return this.colunas
        },
        prefix(){
            return this.prefixOuSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixOuSuffixValor === '%' ? '%' : ''
        },
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    mounted() {
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .120 * window.innerWidth
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped>
.tabela-item-detalhe {
    border-top: 1px solid #ebebeb;
    padding: 16px;
}

@media (max-width: 720px) {
    .tabela-item-detalhe {
        padding: 0;
    }

    .tabela-item-detalhe td:nth-of-type(1):before {
        content: "Sequência:";
    }

    .tabela-item-detalhe td:nth-of-type(2):before {
        content: "Descrição:";
    }

    .tabela-item-detalhe td:nth-of-type(3):before {
        content: "Unidade:";
    }

    .tabela-item-detalhe td:nth-of-type(4):before {
        content: "Quantidade:";
    }

    .tabela-item-detalhe td:nth-of-type(5):before {
        content: "Estimado Unitário (R$):";
    }

    .tabela-item-detalhe td:nth-of-type(3) {
        text-align: left;
    }

    .tabela-item-detalhe td:nth-of-type(4) {
        text-align: left;
    }

    .tabela-item-detalhe td:nth-of-type(5) {
        text-align: left;
    }
}
</style>